import {isDefaultSite, createClass} from '../../commons/ui-commons';
import { getIsWidget, getPartnerName } from '../../lhs/reducers/configuration-reducer';
//import styles from "../../lhs/css/nab.css";
/**
 * parse Through existing css classes and store color themes
 * 
 */

var primaryColor,primarySwatch;

function createStyleJson() {
  var styleJson = {};
  try{
    styleJson["color_theme_primary"] = window.getComputedStyle(document.querySelector('.color_theme_primary')).getPropertyValue('color') + ' !important';
    styleJson["theme_logo"] = window.getComputedStyle(document.querySelector('.theme_logo')).getPropertyValue('background-image');
    if(!getIsWidget()){
      styleJson["bg_color_navbar_background"] = window.getComputedStyle(document.querySelector('.apiReference .bg_color_navbar_background')).getPropertyValue('background-color');
      styleJson["bg_color_navbar_selected_bg_color"] = window.getComputedStyle(document.querySelector('.apiReference .bg_color_navbar_selected_bg_color')).getPropertyValue('background-color');
      styleJson["bg_color_navbar_indicator_bar"] = window.getComputedStyle(document.querySelector('.apiReference .bg_color_navbar_indicator_bar')).getPropertyValue('background-color');
      styleJson["color_navbar_text_and_icon"] = window.getComputedStyle(document.querySelector('.apiReference .color_navbar_text_and_icon')).getPropertyValue('color');
    }
    return styleJson;
  }
  catch(err){
    return null;
  }
}

function addCheckboxImages(partnerID){
  const homePage = require('../../dist/json/config.json');
  var pathPrefix = (homePage.homepage == "" ? '/' : homePage.homepage);
  
  // Original tree checkboxes
  createClass('.rct-icons-fa5 .rct-icon-uncheck::before','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-empty.svg) !important')
  createClass('.rct-icons-fa5 .rct-icon-check::before','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-filled.svg) !important')
  createClass('.rct-icons-fa5 .rct-icon-half-check::before','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-indeterminate.svg) !important')
  
  // Virtualized tree checkboxes - using custom images instead of Font Awesome
  createClass('.virtualized-js-tree-container .rc-tree-checkbox','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-empty.svg) !important; font-family: inherit !important;')
  createClass('.virtualized-js-tree-container .rc-tree-checkbox-checked','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-filled.svg) !important; font-family: inherit !important;')
  createClass('.virtualized-js-tree-container .rc-tree-checkbox-indeterminate','content: url('+pathPrefix+'images/treeview/'+partnerID+'/checkbox-indeterminate.svg) !important; font-family: inherit !important;')
}

function addClassesToPage(primaryColor,logoImage,navbarBackground,navbarText) {
  createClass('.border_color_theme_primary_bottom_shadow', 'box-shadow: 0 0.5rem 0 0 ' + primaryColor);
  createClass('.border_color_theme_primary_bottom', 'border-bottom: 4px solid '+ primaryColor);
  createClass('.border_color_theme_primary_bottom_thin', 'border-bottom: 2px solid '+ primaryColor);
  createClass('.css-1wjqh8f-CSS-CSS-white-bg-bg', 'width: unset !important');
  createClass('.css-wizvvb.vds-tab:active','box-shadow : ' + primaryColor +' 0px -2px 0px inset');
  createClass('.vds-card--content-separator','background-color: ' + primaryColor);
  createClass('.CodeMirror-linenumber','color: ' + primaryColor);
  createClass('div[role^="progressbar"]', 'color: '+primaryColor);
  createClass('.api-reference #headerExample div[data-test^=default-cybsChip].vds-chip', 'background-color: '+primaryColor);
  createClass('.css-wizvvb.vds-tab:active','box-shadow : ' + primaryColor +' 0px -2px 0px inset');
  createClass("#static-home-section .vds-btn-label", 'color: ' + primaryColor);
  createClass('#LiveConsole .vds-state--selected', 'border-bottom: 3px solid '+ primaryColor);
  createClass('#request-tabs .vds-state--selected', 'border-bottom: 3px solid '+ primaryColor);
  if(logoImage){
    createClass('#whitelabeled-logo', 'background: '+logoImage + 'center no-repeat !important');
  }
  var borderElementsPrimaryColor = ['#urlEditor>div:focus', '#urlEditor>div:hover','#processorInfo .vds-input-bar:focus', '#processorInfo .vds-input-bar:hover'];
  for (var i = 0; i < borderElementsPrimaryColor.length; i++) {
    createClass(borderElementsPrimaryColor[i], 'border-color: ' + primaryColor);
  }
  var fillColorElements = ['.color_theme_primary_fill', '.css-5mfa4b','.css-5mfa4b', '.css-5mfa4b.vds-icon use' ,'#sampleRequestDropDownDiv use', '.alert-required-fields .vds-alert.vds-alert--information .vds-alert-icon svg use', '.rc-tree-title-content svg'];
  for (var i = 0; i < fillColorElements.length; i++) {
    createClass(fillColorElements[i], 'fill : ' + primaryColor);
  }
  createClass('.rct-checkbox','color : ' + primaryColor);
  createClass('.rct-node-icon','color : ' + primaryColor);
  if(!getIsWidget()){
    createClass('.api-lifecycle','background-color: '+navbarText);
    createClass('.api-lifecycle','color: '+navbarBackground);
  }
  addCheckboxImages(getPartnerName());
}

function applyWhitelabeledStyles(){
  const styleJson = createStyleJson();
  if(styleJson){
    primaryColor = styleJson["color_theme_primary"];
    document.documentElement.style.setProperty('--palette-default-active-hover', styleJson["color_navbar_text_and_icon"]);
    document.documentElement.style.setProperty('--palette-default-active-pressed', styleJson["color_navbar_text_and_icon"]);
    document.documentElement.style.setProperty('--palette-default-active-subtle', styleJson["color_navbar_text_and_icon"]);
    document.documentElement.style.setProperty('--palette-default-text', styleJson["color_navbar_text_and_icon"]);
    document.documentElement.style.setProperty('--palette-default-text-subtle', styleJson["color_navbar_text_and_icon"]);
    document.documentElement.style.setProperty('--palette-default-text-on-active', styleJson["color_navbar_text_and_icon"]);

    document.documentElement.style.setProperty('--v-tabs-selected-highlight', styleJson["bg_color_navbar_indicator_bar"],);
    document.documentElement.style.setProperty('--palette-default-active', styleJson["bg_color_navbar_indicator_bar"]);

    document.documentElement.style.setProperty('--palette-default-surface-1', styleJson["bg_color_navbar_background"]);

    document.documentElement.style.setProperty('--palette-default-surface-2', styleJson["bg_color_navbar_selected_bg_color"]);
    document.documentElement.style.setProperty('--palette-default-surface-highlight', styleJson["bg_color_navbar_selected_bg_color"]);
    document.documentElement.style.setProperty('--palette-default-surface-lowlight', styleJson["bg_color_navbar_selected_bg_color"]);

    primarySwatch = {
      isSwatch: {
        primary: styleJson["color_theme_primary"].split('!')[0].trim()
      },
    }
    addClassesToPage(styleJson["color_theme_primary"], styleJson["theme_logo"], styleJson["bg_color_navbar_background"], styleJson["color_navbar_text_and_icon"]);
  }
  else{
    applyDefaultStyles();
  }
}

function applyDefaultStyles(){
  primaryColor = '#2b6afd';
  primarySwatch = {
    isSwatch: {
      primary: '#2b6afd'
    },
  }

  createClass('.border_color_theme_primary', 'border-color: #2B6AFD !important');
  createClass('#static-api-endpoints-section .gridRowHeader th', 'border-bottom: 2px solid #2BA6FD');
  createClass('.api-lifecycle','background-color: white');
  createClass('.api-lifecycle','color: #202A44');
  var borderElementsPrimaryColor = ['#urlEditor>div:focus', '#urlEditor>div:hover','#processorInfo .vds-input-bar:focus', '#processorInfo .vds-input-bar:hover'];
  for (var i = 0; i < borderElementsPrimaryColor.length; i++) {
    createClass(borderElementsPrimaryColor[i], 'border-color: #2B6AFD !important');
  }
  addCheckboxImages('cybs');
}

function storeThemeData() {
  if (!isDefaultSite()) {
    applyWhitelabeledStyles();
  }
  else
  {
    applyDefaultStyles();
  }
}

function getPrimaryColor(){
  return primaryColor;
}
function getPrimarySwatch(){
  return primarySwatch;
}

export default storeThemeData;
export { storeThemeData, getPrimaryColor, getPrimarySwatch}
